import { render } from "./product-card-sawmill.vue?vue&type=template&id=e77e2f4a"
import script from "./product-card-sawmill.vue?vue&type=script&lang=js"
export * from "./product-card-sawmill.vue?vue&type=script&lang=js"

import "./product-card-sawmill.vue?vue&type=style&index=0&id=e77e2f4a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__